import {
  Button,
  CircularProgress,
  Container,
  Divider,
  FormLabel,
  Grid,
  Typography,
} from "@mui/material";
import moment from "moment";
import { Box } from "@mui/system";
import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { useQuery } from "react-query";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

// Clients Details View Component
const ClientsDetail = ({ handleViewModalClose, clientId }) => {
  // SNACKBAR
  const { enqueueSnackbar } = useSnackbar();

  // CUSTOM HOOK
  const axiosPrivate = useAxiosPrivate();

  // QUERY
  const { isLoading, data, isFetching, error } = useQuery(
    ["clients"],
    () => {
      return axiosPrivate.get(`/clients/${clientId}`);
    },
    {
      refetchOnWindowFocus: false,
      enable: false,
    }
  );

  // USEFFECTS
  useEffect(() => {
    if (error) {
      enqueueSnackbar(
        error?.response?.data?.error?.message ||
          error?.message ||
          "Network Error!",
        {
          variant: "error",
          preventDuplicate: true,
          autoHideDuration: 2000,
        }
      );
    }
  }, [enqueueSnackbar, error]);

  // RENDER
  return (
    <Grid
      container
      sx={{
        minHeight: "100vh",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Container maxWidth="sm">
        <Box sx={{ display: "flex", flexDirection: "column", my: 3 }}>
          <Typography variant="h6" sx={{ textAlign: "center", mb: 1 }}>
            Client Details
          </Typography>
          <Divider sx={{ mb: 2 }} />
          {isLoading || isFetching ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                my: 3,
              }}
            >
              <CircularProgress size={30} />
            </Box>
          ) : (
            <>
              <Box sx={{ display: "flex", alignItems: "flex-start", my: 1 }}>
                <FormLabel sx={{ minWidth: 160 }}>ID</FormLabel>
                <Typography sx={{ ml: 2 }}>{data?.data?.data?.id}</Typography>
              </Box>
              <Divider />
              <Box sx={{ display: "flex", alignItems: "flex-start", my: 1 }}>
                <FormLabel sx={{ minWidth: 160 }}>Name</FormLabel>
                <Typography sx={{ ml: 2 }}>{data?.data?.data?.name}</Typography>
              </Box>
              <Divider />
              <Box sx={{ display: "flex", alignItems: "flex-start", my: 1 }}>
                <FormLabel sx={{ minWidth: 160 }}>Client Type</FormLabel>
                <Typography sx={{ ml: 2 }}>
                  {data?.data?.data?.client_type}
                </Typography>
              </Box>
              <Divider />
              <Box sx={{ display: "flex", alignItems: "flex-start", my: 1 }}>
                <FormLabel sx={{ minWidth: 160 }}>Logo URL</FormLabel>
                <Typography sx={{ ml: 2, wordBreak: "break-all" }}>
                  {data?.data?.data?.logo_url}
                </Typography>
              </Box>
              <Divider />
              <Box sx={{ display: "flex", alignItems: "flex-start", my: 1 }}>
                <FormLabel sx={{ minWidth: 160 }}>Scopes</FormLabel>
                <Typography sx={{ ml: 2, whiteSpace: "pre-wrap" }}>
                  {data?.data?.data?.scopes}
                </Typography>
              </Box>
              <Divider />
              <Box sx={{ display: "flex", alignItems: "flex-start", my: 1 }}>
                <FormLabel sx={{ minWidth: 160 }}>Redirect URIs</FormLabel>
                <Box sx={{ ml: 2 }}>
                  {data?.data?.data?.redirect_uris?.map((uri, idx) => (
                    <Typography key={`redir_${idx}`}>{uri}</Typography>
                  ))}
                </Box>
              </Box>
              <Divider />
              <Box sx={{ display: "flex", alignItems: "flex-start", my: 1 }}>
                <FormLabel sx={{ minWidth: 160 }}>Post-Logout URIs</FormLabel>
                <Box sx={{ ml: 2 }}>
                  {data?.data?.data?.post_logout_redirect_uris?.map(
                    (uri, idx) => (
                      <Typography key={`postredir_${idx}`}>{uri}</Typography>
                    )
                  )}
                </Box>
              </Box>
              <Divider />
              <Box sx={{ display: "flex", alignItems: "flex-start", my: 1 }}>
                <FormLabel sx={{ minWidth: 160 }}>
                  Backchannel Logout URI
                </FormLabel>
                <Typography sx={{ ml: 2, wordBreak: "break-all" }}>
                  {data?.data?.data?.backchannel_logout_uri}
                </Typography>
              </Box>
              <Divider />
              <Box sx={{ display: "flex", alignItems: "flex-start", my: 1 }}>
                <FormLabel sx={{ minWidth: 160 }}>Status</FormLabel>
                <Typography sx={{ ml: 2 }}>
                  {data?.data?.data?.status}
                </Typography>
              </Box>
              <Divider />
              <Box sx={{ display: "flex", alignItems: "flex-start", my: 1 }}>
                <FormLabel sx={{ minWidth: 160 }}>Created At</FormLabel>
                <Typography sx={{ ml: 2 }}>
                  {moment(data?.data?.data?.created_at).format("llll")}
                </Typography>
              </Box>
              <Divider />
            </>
          )}
          <Divider />
          <Box sx={{ mt: 2, display: "flex" }}>
            <Button fullWidth variant="outlined" onClick={handleViewModalClose}>
              Close
            </Button>
          </Box>
        </Box>
      </Container>
    </Grid>
  );
};
export default ClientsDetail;
